module.exports = __webpack_public_path__ + "img/256x256_hexagon_partial_warp_gate.80d96708.svg";